module.exports = __webpack_public_path__ + "static/media/galerija_2017 (33).7a7053df.jpg";